import React, {Component} from "react";
import {
    FormGroup,
    ControlLabel,
    FormControl,
    Row,
    Col,
    Checkbox,
    InputGroup,
    OverlayTrigger,
    Popover,
    Button
}                         from "react-bootstrap";
import Select             from "react-select";
import                         "react-select/dist/react-select.css";
import Dropzone           from "react-dropzone";
import ic_add_image       from "../../../assets/image/ic_add_image.svg";
import DateTime           from "react-datetime";
import                         "style/react-datetime.css";
import style from "../../Evoucher/style.less";
import {
  IS_VALID
}                         from "utils";

import Loader             from "../../Loader";

class Create extends Component {
    constructor (props) {
        super(props);

        this.dropzoneRef;

        this.state = {
            isLoadingRelation: false
        };
    
        this.getRelation = this.getRelation.bind(this);
    }

    getRelation () {
        let {
            actions,
            PointsBanner,
            getRelation
          } = this.props;
      
          let {
            formType,
            selectedData
          } = PointsBanner;
      
          if (IS_VALID(selectedData) && (formType.toUpperCase() === "UPDATE" || formType.toUpperCase() === "DUPLICATE")) {
      
            this.setState({ isLoadingRelation: true });
      
            getRelation()
            .then(([ cardType, specificUser, blacklistedUser ]) => {
              let cardTypeArray = cardType.map((item) => ({
                label: item.get("name"),
                value: item.id
              }));
      
              let specificUserArray = specificUser.map((item) => ({
                label: `${IS_VALID(item.get("memberId")) ? item.get("memberId") : ""} ${IS_VALID(item.get("name")) ? item.get("name") : ""}`,
                value: item.id
              }));
      
              let blacklistedUserArray = blacklistedUser.map((item) => ({
                label: `${IS_VALID(item.get("memberId")) ? item.get("memberId") : ""} ${IS_VALID(item.get("name")) ? item.get("name") : ""}`,
                value: item.id
              }));
      
              this.setState({ isLoadingRelation: false });
      
              actions.setValue(
                {
                  cardType: cardTypeArray,
                  specificUser: specificUserArray,
                  blacklistedUser: blacklistedUserArray
                }
              );
            })
            .catch((err) => {
              console.log("err", err);
              this.setState({ isLoadingRelation: false });
            });
        }
    }

    render () {
        let {
            isLoadingRelation
        } = this.state;

        let {
            PointsBanner,
            actions,

            loadOptions,
            uploadSpecificUserCSVFile
        } = this.props;

        let {
            isLoadingAction,

            image,
            browser,
            url,
            sort,
            isEasyPromos,
            promoId,
            visibilityType,
            visibilityStartTime,
            visibilityEndTime,
            campaignStartDate,
            campaignEndDate,

            cardType,
            specificUser,
            blacklistedUser,
            deviceType,
            isUploadingCSVFile,
            isUploadingCSVFileBlacklistedUser,

            browserOptions,
            visibilityOptions,
            deviceTypeOptions
        } = PointsBanner;

        let requiredSpan = <span style={{ color: "red" }}>*</span>;
        let loadingComponent = (
            <div style={{ textAlign: "center" }}>
              <i className="fa fa-spinner fa-spin"></i>
            </div>
        );
        let popupMessage = (component, message) => {
            return (
                <OverlayTrigger
                placement="top"
                id={message}
                overlay={
                    <Popover>
                    {message}
                    </Popover>
                }
                >
                {component}
                </OverlayTrigger>
            );
        };

        let imageSrc = ic_add_image,
            imageStyle = {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: 'auto',
                width: '100px',
                height: '100%'
            },
            dropZoneStyle = {
                display: "inline-block",
                verticalAlign: "top"
            },
            isHideX = {
                display: 'none'
            };

        if (IS_VALID(image)) {
            imageSrc = image.preview || image.url;
            imageStyle = {
            ...imageStyle,
            width: '',
            maxWidth: '100%',
            maxHeight: '100%'
            };
            dropZoneStyle = {
            verticalAlign: "middle"
            };
            isHideX = {};
        }

        let isCardTypeFieldDisabled = specificUser.length !== 0 ? true : false,
            isSpecificUserFieldDisabled = cardType.length !== 0 ? true : false;


        return (
            <form>
                <Loader loading={isLoadingAction}/>
                <FormGroup style={{ position: "relative" }}>
                    <ControlLabel>Image {requiredSpan}</ControlLabel>
                    <div
                        style={{
                            position: 'absolute',
                            width: '30px',
                            height: '30px',
                            background: 'red',
                            paddingTop: '4px',
                            top: '12px',
                            right: '-12px',
                            textAlign: 'center',
                            borderRadius: '50px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            ...isHideX
                        }}
                        onClick={() => {
                            actions.setValue({ image: null });
                        }}
                    >
                        x
                    </div>
                    <Dropzone
                        style={{
                            position: "",
                            width: "100%",
                            height: "200px",
                            border: "1px solid #e1e1e1",
                            borderRadius: "0px",
                            backgroundColor: "#f5f5f5",
                            ...dropZoneStyle
                        }}
                        accept="image/*"
                        multiple={false}
                        onDropAccepted={(acceptedArray) => {
                            actions.setValue({ image: acceptedArray[0] });
                        }}
                    >
                        <img
                            style={imageStyle}
                            src={imageSrc}
                        />
                    </Dropzone>
                </FormGroup>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Browser</ControlLabel>
                            <Select
                                options={browserOptions}
                                value={browser}
                                onChange={(value) => {
                                    let stateToUpdate = {
                                        browser: value
                                    };

                                    if (!IS_VALID(value)) {
                                        stateToUpdate.url = "";
                                        stateToUpdate.isEasyPromos = false;
                                        stateToUpdate.promoId = "";
                                    }

                                    actions.setValue(stateToUpdate);
                                }}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between"
                                }}
                            >
                                <span>
                                    URL {IS_VALID(browser) && requiredSpan}
                                </span>
                                <Checkbox
                                    inline
                                    disabled={!IS_VALID(browser)}
                                    checked={isEasyPromos}
                                    onChange={(e) => {
                                        let stateToUpdate = {
                                            isEasyPromos: e.target.checked
                                        };

                                        if (!e.target.checked) {
                                            stateToUpdate.promoId = "";
                                        }

                                        actions.setValue(stateToUpdate);
                                    }}
                                >
                                    EasyPromos
                                </Checkbox>
                            </ControlLabel>
                            <FormControl
                                disabled={!IS_VALID(browser)}
                                type="text"
                                placeholder="Enter Url..."
                                value={url}
                                onChange={(e) => {
                                    actions.setValue({
                                        url: e.target.value
                                    });
                                }}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Sort {requiredSpan}</ControlLabel>
                            <FormControl
                                type="number"
                                placeholder="Enter Sort..."
                                value={sort}
                                onChange={(e) => {
                                    actions.setValue({
                                        sort: e.target.value.replace(/[^0-9.]/g, "")
                                    });
                                }}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Promo ID {isEasyPromos && requiredSpan}</ControlLabel>
                            <FormControl
                                placeholder="Enter Promo ID..."
                                disabled={!isEasyPromos}
                                value={promoId}
                                onChange={(e) => {
                                    actions.setValue({
                                        promoId: e.target.value
                                    });
                                }}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Visibility Type {requiredSpan}</ControlLabel>
                            <Select
                                options={visibilityOptions}
                                value={visibilityType}
                                onChange={(value) => {
                                    let stateToUpdate = {
                                        visibilityType: value
                                    };

                                    if (!IS_VALID(value)) {
                                        stateToUpdate.visibilityStartTime = "";
                                        stateToUpdate.visibilityEndTime = "";
                                    }

                                    actions.setValue(stateToUpdate);
                                }}
                            />
                        </FormGroup>
                        {visibilityType && visibilityType.value && visibilityType.value === "TR" &&
                        <FormGroup>
                            <ControlLabel>Visibility Time {requiredSpan}</ControlLabel>
                            <InputGroup>
                                <DateTime
                                    dateFormat={false}
                                    timeFormat='hh:mm A'
                                    value={visibilityStartTime}
                                    onChange={(datetime) => {
                                        actions.setValue({ visibilityStartTime: datetime });
                                    }}
                                    inputProps={{
                                        placeholder: "Start Time",
                                        style: {
                                            position: "initial",
                                            borderRadius: "4px 0 0 4px"
                                        }
                                    }}
                                />
                                <InputGroup.Addon>TO</InputGroup.Addon>
                                <DateTime
                                    dateFormat={false}
                                    timeFormat='hh:mm A'
                                    value={visibilityEndTime}
                                    onChange={(datetime) => {
                                        actions.setValue({ visibilityEndTime: datetime });
                                    }}
                                    inputProps={{
                                        placeholder: "End Time",
                                        style: {
                                            position: "initial",
                                            borderRadius: "0 4px 4px 0"
                                        }
                                    }}
                                />
                            </InputGroup>
                        </FormGroup>}
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Campaign Date</ControlLabel>
                            <InputGroup>
                                <DateTime
                                    dateFormat="MMM DD, YYYY"
                                    timeFormat={false}
                                    value={campaignStartDate}
                                    onChange={(datetime) => {
                                        actions.setValue({ campaignStartDate: datetime });
                                    }}
                                    inputProps={{
                                        placeholder: "Start Date",
                                        style: {
                                            position: "initial",
                                            borderRadius: "4px 0 0 4px"
                                        }
                                    }}
                                />
                                <InputGroup.Addon>TO</InputGroup.Addon>
                                <DateTime
                                    dateFormat="MMM DD, YYYY"
                                    timeFormat={false}
                                    value={campaignEndDate}
                                    onChange={(datetime) => {
                                        actions.setValue({ campaignEndDate: datetime });
                                    }}
                                    inputProps={{
                                        placeholder: "End Date",
                                        style: {
                                            position: "initial",
                                            borderRadius: "0 4px 4px 0"
                                        }
                                    }}
                                />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>
                            Card Type&nbsp;
                            {isCardTypeFieldDisabled ? (
                                popupMessage(
                                <i className="fa fa-info-circle"></i>,
                                "Specific User is already assigned."
                                )
                            ) : (
                                ""
                            )}
                            </ControlLabel>
                            {isLoadingRelation ? (
                            loadingComponent
                            ) : (
                            <Select.Async
                                multi={true}
                                disabled={isCardTypeFieldDisabled}
                                placeholder="Select or Search..."
                                loadOptions={(input, cb) => loadOptions(input, cb, "VoucherCardType", "name")}
                                value={cardType}
                                onChange={(value) => actions.setValue({ cardType: value })}
                                className={style.select}
                                />
                            )}
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Device Type</ControlLabel>
                            <Select
                                clearable={false}
                                options={deviceTypeOptions}
                                value={deviceType}
                                onChange={(deviceType) => {
                                    actions.setValue({
                                        deviceType
                                    });
                                }}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>
                            Specific User&nbsp;
                            {isSpecificUserFieldDisabled ? (
                            popupMessage(
                                <i className="fa fa-info-circle"></i>,
                                "Card Type is already assigned."
                            )
                            ) : (
                            ""
                            )}
                            {IS_VALID(specificUser) && specificUser.length > 0 ? (
                            `: Total ${specificUser.length}`
                            ) : (
                            ""
                            )}
                            </ControlLabel>
                            {isLoadingRelation ? (
                                loadingComponent
                            ) : (
                                <div>
                                <Select.Async
                                    placeholder="Select or Search..."
                                    multi={true}
                                    disabled={isSpecificUserFieldDisabled}
                                    loadOptions={(input, cb) => loadOptions(input, cb, "MemberDetail")}
                                    value={specificUser}
                                    onChange={(value) => actions.setValue({ specificUser: value })}
                                    className={style.select}
                                    />
                                <br/>
                                <Row>
                                    <Col md={IS_VALID(specificUser) && specificUser.length > 10 ? 6 : 12}>
                                    <Button
                                        style={{ width: "100%" }}
                                        disabled={isUploadingCSVFile || isSpecificUserFieldDisabled}
                                        onClick={() => {
                                        this.dropzoneRef.name = "specificUser";
                                        this.dropzoneRef.open();
                                        }}>
                                        {isUploadingCSVFile ? (
                                        <i className="fa fa-spinner fa-spin"></i>
                                        ) : (
                                        <b>UPLOAD SPECIFIC USER CSV</b>
                                        )}
                                    </Button>
                                    <p style={{ margin: "10px 0 0" }}>Note: CSV file must have a "memberId" column</p>
                                    </Col>
                                </Row>
                                </div>
                            )}
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>
                                Excluded User&nbsp;
                                {IS_VALID(blacklistedUser) && blacklistedUser.length > 0 ? (
                                `: Total ${blacklistedUser.length}`
                                ) : (
                                ""
                                )}
                            </ControlLabel>
                            {isLoadingRelation ? (
                                loadingComponent
                            ) : (
                                <div>
                                <Select.Async
                                    placeholder="Select or Search..."
                                    multi={true}
                                    loadOptions={(input, cb) => loadOptions(input, cb, "MemberDetail")}
                                    value={blacklistedUser}
                                    onChange={(value) => actions.setValue({ blacklistedUser: value })}
                                    className={style.select}
                                    />
                                <br/>
                                <Row>
                                    <Col md={IS_VALID(blacklistedUser) && blacklistedUser.length > 10 ? 6 : 12}>
                                    <Button
                                        style={{ width: "100%" }}
                                        disabled={isUploadingCSVFileBlacklistedUser}
                                        onClick={() => {
                                        this.dropzoneRef.name = "blacklistedUser";
                                        this.dropzoneRef.open();
                                        }}>
                                        {isUploadingCSVFileBlacklistedUser ? (
                                        <i className="fa fa-spinner fa-spin"></i>
                                        ) : (
                                        <b>UPLOAD EXCLUDED USER CSV</b>
                                        )}
                                    </Button>
                                    <p style={{ margin: "10px 0 0" }}>Note: CSV file must have a "memberId" column</p>
                                    </Col>
                                </Row>
                                </div>
                            )}
                        </FormGroup>
                    </Col>
                </Row>
                <Dropzone
                accept=".csv, text/csv"
                style={{ display: "none" }}
                multiple={false}
                ref={(ref) => { this.dropzoneRef = ref; }}
                onDropAccepted={(acceptedArray) => {
                    uploadSpecificUserCSVFile(acceptedArray[0], this.dropzoneRef.name);
                }}
                />
            </form>
        );
    }

    componentDidMount () {
        this.getRelation();
    }
}

import {connect} from "react-redux";

function mapStateToProps(state) {
	let {
        PointsBanner
	} = state;

	return {
        PointsBanner
	};
}

export default connect(mapStateToProps)(Create);


// WEBPACK FOOTER //
// ./components/PointsBanner/FormContainer/Create.js